<template>
  <div id="sizeChartModal" class="uk-flex-top" data-uk-modal>
    <div class="uk-modal-dialog uk-margin-auto-vertical">
      <button class="uk-modal-close-default" type="button" aria-label="close" data-uk-close />

      <div class="uk-modal-header uk-padding uk-padding-remove-bottom uk-margin-bottom" style="border: none">
        <h3 class="h4 uk-text-bold">Find your size</h3>
      </div>

      <div class="uk-modal-body uk-padding uk-padding-remove-top" data-uk-overflow-auto>
        <p>
          <strong>Example:</strong>
          <br />
          If you are 6’(183cm) tall, weigh 175lbs(80kg), chest 40’(101cm), waist 33’(84cm) we suggest size
          <strong>LARGE</strong>
        </p>

        <!--Size Calculator-->
        <div id="sizes" class="uk-margin-medium-bottom">
          <div class="uk-margin-bottom uk-flex">
            <label class="w-radio uk-margin-small-right uk-flex uk-flex-middle">
              <input
                id="inchesRecMen"
                class="uk-radio"
                style="background-size: 32px; height: 1rem; width: 1rem"
                type="radio"
                :checked="selectedLocal === 'inches'"
                @click="handleChoseLocal('inches')"
              />
              <span class="w-label">In inches</span>
            </label>

            <label class="w-radio uk-flex uk-flex-middle">
              <input
                id="cmRecMen"
                class="uk-radio"
                style="background-size: 32px; height: 1rem; width: 1rem"
                type="radio"
                :checked="selectedLocal === 'centimeters'"
                @click="handleChoseLocal('centimeters')"
              />
              <span class="w-label">In centimeters</span>
            </label>
          </div>

          <div class="uk-child-width-1-2 uk-grid-small uk-margin-bottom uk-grid" data-uk-grid>
            <div>
              <label class="uk-text-small uk-margin-small-bottom uk-display-block uk-text-bold" for="sizeChest">
                Chest size (in):
              </label>
              <select
                id="sizeChest"
                v-model="selectedChest"
                class="uk-select"
                style="font-size: 0.875rem; text-indent: 8px"
                name="sizeChest"
                aria-label="Chest size"
                required
              >
                <option disabled selected />
                <option v-for="(chest, index) in chestOptions" :key="chest.value" :value="index">
                  {{ chest.label }}
                </option>
              </select>
            </div>
            <div>
              <label class="uk-text-small uk-margin-small-bottom uk-display-block uk-text-bold" for="sizeSleeve">
                Sleeve length (in):
              </label>
              <select
                id="sizeSleeve"
                v-model="selectedWaist"
                class="uk-select"
                style="font-size: 0.875rem; text-indent: 8px"
                name="sizeSleeve"
                aria-label="Sleeve length"
                required
              >
                <option disabled selected />
                <option v-for="(waist, index) in waistOptions" :key="waist.value" :value="index">
                  {{ waist.label }}
                </option>
              </select>
            </div>
          </div>

          <p>
            Your recommended size is:
            <strong class="uk-h4 uk-text-bold uk-margin-small-left">{{ sizeOut }}</strong>
          </p>
        </div>
        <!-- /Size Calculator-->

        <ul style="border-bottom: 1px solid #e5e7e8; border-top: 1px solid #e5e7e8" data-uk-accordion>
          <SizingTab :gender="gender" :archetype="archetype" :sizes="productSizes" />
          <li class="uk-margin-remove" style="border-top: 1px solid #e5e7e8">
            <a class="uk-accordion-title uk-text-small uk-padding-small uk-padding-remove-horizontal" href="#">
              Not sure which size to choose?
            </a>
            <div class="uk-accordion-content">
              <p class="uk-text-small uk-margin-bottom">
                The sizes we recommended are only suggestions. We are not responsible if you order an incorrect size. If
                you are unsure of your size please write to us first.
              </p>

              <div class="uk-margin-bottom">
                <contact-form :csrf="csrf" :route="route" form-id="size_to_choose" submit-text="Get in touch" />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ContactForm from '@/web/vue/shared/components/ContactForm.vue'
import { sizesData } from '@/web/vue/shared/constants/sizesData'

import SizingTab from './SizingTab.vue'

export default {
  name: 'ProductSizeChartModal',
  components: { ContactForm, SizingTab },
  props: {
    route: {
      type: String,
      default: '',
    },
    csrf: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedLocal: 'inches',
      selectedChest: null,
      selectedWaist: null,
    }
  },
  computed: {
    ...mapGetters({ product: 'basket/currentProduct' }),
    productSizes() {
      return this.product?.sizes || []
    },
    archetype() {
      return this.product?.archetype || ''
    },
    gender() {
      return this.product?.gender || 'male'
    },
    currentSizes() {
      return sizesData[this.archetype] || {}
    },
    chestOptions() {
      return this.getOptions(this.currentSizes[this.selectedLocal]?.chest)
    },
    waistOptions() {
      return this.getOptions(this.currentSizes[this.selectedLocal]?.sleeve)
    },
    sizeOut() {
      return this.selectedChest !== null || this.selectedWaist !== null
        ? this.chestOptions[Math.max(this.selectedChest, this.selectedWaist)]?.shortName
        : '...'
    },
  },
  methods: {
    handleChoseLocal(type) {
      this.selectedLocal = type
      this.selectedChest = null
      this.selectedWaist = null
    },
    getOptions(options = []) {
      return options.filter(option => Boolean(this.productSizes.find(s => s.name === option.name)))
    },
  },
}
</script>
